module.exports = __webpack_public_path__ + "img/a011_9.d6c5d357.png";